import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { KpiList } from 'src/app/core/models/insight-configuration.model';
import { GetKpiList, SetSelectedImpactedKPIs } from 'src/app/core/store/ewb-configuration/ewb-configuration.action';
import _ from 'lodash';

@Component({
  selector: 'app-ewb-impacted-kpi-selection-popup',
  templateUrl: './ewb-impacted-kpi-selection-popup.component.html',
  styleUrls: ['./ewb-impacted-kpi-selection-popup.component.scss']
})
export class EwbImpactedKpiSelectionPopupComponent implements OnInit, AfterViewChecked {
 public kpiList : KpiList[]
  public count = 0
  public allSelected: boolean = false;
  public someSelected: boolean = false;
  public kpisLoading: boolean = true;
  public selectedPlant: any;

  form: UntypedFormGroup;

  constructor(
    public modalRef: BsModalRef,
    public store: Store,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getKpiList();
    this.initiateForm();
    this.getSelectedPlant();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  public getSelectedPlant() {
    //to get the selected Plant option
    this.selectedPlant =  this.store.selectSnapshot(state => state.configurations.selectedPlant);
  }


  public selectAll(selected: boolean){
    this.allSelected = selected
    if(this.kpiList === null) {
      return;
    }
    this.kpiList.forEach(kpi => kpi.selected = selected);
    this.checkSomeSelected();
  }

  public onKpiSelected() {
    if(this.kpiList.length > 0){
      this.allSelected = this.kpiList?.every(kpi => kpi.selected);
      this.checkSomeSelected();
    }
  }

  public checkSomeSelected() {
    this.someSelected = this.kpiList.filter(kpi => kpi.selected).length > 0 && !this.allSelected;
    this.count = this.kpiList.filter(kpi => kpi.selected).length;
  }

  public initiateForm(): void{
    this.form = this.fb.group({
      kpi: this.fb.array([]),
    });
  }

  public getKpiList() {
    //Get Impacted KPI list based from plant
    this.kpiList = this.store.selectSnapshot(state => state.configurations.ewb.impactedKpiSelection)
    let selectedPlantId =  this.store.selectSnapshot(state => state.configurations.selectedPlant?.plantId);
    this.filterSelected();
    this.onKpiSelected();
    if(this.kpiList.length === 0) {
      this.store.dispatch(new GetKpiList(selectedPlantId))
      .subscribe(() => {
        this.kpiList = this.store.selectSnapshot(state => state.configurations.ewb.impactedKpiSelection);
        this.filterSelected();
        this.onKpiSelected();
        this.kpisLoading = false;
      })
    }else{
      this.kpisLoading = false;
    }
  }

  public filterSelected() {
    const selectedKPIs = this.store.selectSnapshot(state => state.configurations.ewb.impactedKpiSelected);
    this.kpiList = this.kpiList.map((kpi) => {
      kpi.selected = !!selectedKPIs.find(selectedKpi => selectedKpi.uid === kpi.uid)
      return kpi;
    })
  }

  submit() {
    const selectedKpis = _.cloneDeep(this.kpiList.filter(kpi => kpi?.selected))
    this.store.dispatch(new SetSelectedImpactedKPIs(selectedKpis)).subscribe(() => {
      this.modalRef.hide();
    })
  }
  
  public onCloseButtonClick() : void {
    this.modalRef.hide();
  }

}
